import { render, staticRenderFns } from "./ProyectoNew.vue?vue&type=template&id=cd04d7ea&scoped=true&"
import script from "./ProyectoNew.vue?vue&type=script&lang=js&"
export * from "./ProyectoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd04d7ea",
  null
  
)

export default component.exports